import React, { useState } from "react";
import PostRequest from "../../service/PostRequest";
import './style.css'
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import InputFeildTextArea from "../Widgets/Inputs/InputFeildTextArea";
import InputSelectionDropdown from "../Widgets/Inputs/InputSelectionDropdown";
import InputFieldText from "../Widgets/Inputs/InputFieldText";

const SalesSupport = () => {

  const [email,setEmail ] = useState("");
  const [fullName,setFullName ] = useState("");
  const [country,setCountry ] = useState("United Kingdom");
  const [message,setmessage ] = useState("");
  const [isWaitingForResponse, setIsWaitingForResponse] = useState(false);
  const [open, setOpen] = useState(false);

  const countryOptions = [
    { value: 'United Kingdom', label: 'United Kingdom' },
    { value: 'India', label: 'India' },
    // Add more options as needed
];

const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handleFullNameChange = (e) => {
    setFullName(e.target.value);
  };

  const handleCountryChange = (e) => {
    setCountry(e.target.value);
  };

  const handleMessageChange = (e) => {
    setmessage(e.target.value);
  };

    
  const handlesendSupportRequest = async (type) => {
    setIsWaitingForResponse(true);
    const data = {
      customerEmail: email,
      customerFullName: fullName,
      country: country,
      message: message,
      supportType:type,
      appId:"Boss"
    };

    console.log("Email has been sent",data);
  
    try {
      const response = await PostRequest(`v1/notification/send/support/confirmation`, data, false);
      console.log(response);
      if (response === undefined) {
        console.log("Request failed");
        setIsWaitingForResponse(false);
      } else {
        console.log("Email sent successfull");
        setIsWaitingForResponse(false);
        handleClickOpen();
      }
    } catch (error) {
      console.error("Email sent failed:", error);
      setIsWaitingForResponse(false);
    }
  }
 
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const footerContent = (
    <div>
        <Button label="Ok" icon="pi pi-check" onClick={() => setOpen(false)} autoFocus />
    </div>
);

  return (
   
    <div className="product-contact-us">
    <br/>
        <div className="contactus-title-container">Sales Enquiry</div><br/>
        <div className="contactus-icon-container"></div><br/>
        <div className="contacus-tagline">Send us an email if you have any questions
            about billing or any other thing</div><br/>
<div className="contact-us-form">

      <InputFieldText value={fullName} onChange={handleFullNameChange} label="Your Full name..."/>
      <InputFieldText value={email} onChange={handleEmailChange} label="Your Email..."/>
      <InputSelectionDropdown 
                            value={country}
                            onChange={handleCountryChange}
                            options={countryOptions}
                            optionLabel="label" 
                            placeholder="Choose your country" 
                    />
      <InputFeildTextArea value={message} onChange={handleMessageChange} label="Your Message..."/>
          
    <div className="contact-us-btn" onClick={() => handlesendSupportRequest("SALES_ENQUIRY")} disabled={isWaitingForResponse}>{isWaitingForResponse ?
      <div>Please wait...</div>
     : 'Send' }</div>
            </div> 
            <Dialog header="Recieved your Sales enquiry" visible={open} onHide={handleClose} footer={footerContent}
                style={{ width: '50vw' }} breakpoints={{ '960px': '75vw', '641px': '100vw' }}>
                <p className="m-0">
                Thankyou for your request,one of the member for Boss team will contact you shortly.
                </p>
            </Dialog>
            </div> 

    
  )
}

export default SalesSupport
